<template>
  <div class="content-panel">
    <a-input-search
      v-model="subcompanyname"
      style="margin-bottom: 8px"
      placeholder="请输入所属公司"
      @search="queryDictData"
      @pressEnter="queryDictData"
    />
    <a-spin :spinning="loading" wrapperClassName="spin" class="leftTopTree">
      <a-card :bordered="false">
        <!--默认展开的-->
        <!--        :defaultExpandedKeys="defaultSelectedKeys"-->
        <a-tree
          style="height:100%"
          v-if="treeData.length > 0"
          :defaultCheckedKeys="defaultSelectedKeys"
          :treeData="treeData"
          :draggable="false"
          @expand="onExpand"
          @select="searchAssetTypeList"
          :showIcon="false"
          :defaultSelectedKeys="defaultSelectedKeys"
          :selectedKeys="selectedKeys"
          :defaultExpandedKeys="defaultSelectedKeys"
        >
          <template slot="custom" slot-scope="item">
            <span class="treeCompanyName">{{ item.url }}</span>
          </template>
        </a-tree>
      </a-card>
    </a-spin>
    <ul v-show="visible && ($auth('centralizedManagement.import') || $auth('centralizedManagement.export'))" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
      <li v-if="$auth('centralizedManagement.import')" @click="handleImport()">导入设备</li>
      <li v-if="$auth('centralizedManagement.export')" @click="derive()">导出当前台账</li>
    </ul>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { getDeptTreeList } from '@/api/assetLedger'
export default {
  name: 'OrgTree',
  components: {
  },
  props: ['isOut'],
  data () {
    return {
      expandedKeys: [],
      loading: false,
      subcompanyname: '',
      treeData: [],
      defaultSelectedKeys: [],
      selectedKeys: [],
      // 用于测试
      code: 'null0',
      visible: false,
      top: 0,
      left: 0,
      numberOfUpdates: 0
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this, { name: 'dept_form' })
  },
  created () {
    // 获取使用部门
    this.getDeptData()
  },
  mounted () {
    this.$nextTick(() => {
      const dom = document.getElementsByClassName('leftTopTree')[0]
      dom.oncontextmenu = this.openContextmenu
    })
  },
  watch: {
    visible (value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  methods: {
    ...mapActions(['handleCentralizedManagementCompanyId']),
    onExpand (expandedKeys) {
      console.log(expandedKeys)
      this.expandedKeys = expandedKeys
    },
    // 关闭右键菜单
    closeMenu () {
      this.visible = false
    },
    openContextmenu (e) {
      e.preventDefault()
      e.stopPropagation()
      this.$emit('closeMenu', 'leftTop')
      this.top = e.pageY - 41
      this.left = e.pageX
      this.visible = true
    },
    // 导入
    handleImport () {
      this.$emit('handleImport')
    },
    // 导出
    derive () {
      this.$emit('derive')
    },
    formateData (arr, id, subcompanycode) {
      const f_arr = []
      const self = this
      if (arr && arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          const item = JSON.parse(JSON.stringify(arr[i]))
          item.key = id + ';' + item.id + Math.floor(Math.random() * 10)
          item.scopedSlots = { title: 'custom' }
          if (item.type === 2) {
            item.subcompanycode = subcompanycode
          }
          if (item.children && item.children.length > 0) {
            item.isCompany = false
            item.children = self.formateData(item.children, item.id, item.subcompanycode)
          } else {
            item.isCompany = true
          }
          f_arr.push(item)
        }
      }
      return f_arr
    },
    // 获取使用部门
    async getDeptData () {
      const data = {
        paging: false,
        subcompanyname: this.subcompanyname
      }
      this.loading = true
      getDeptTreeList(data).then(res => {
        if (res.status === 0) {
          if (res.data.length > 0) {
            res.data.map(item => {
              item.key = String(item.id)
              item.scopedSlots = { title: 'custom' }
              if (item.children && item.children.length > 0) {
                item.isCompany = false
              } else {
                item.isCompany = true
              }
              item.children = this.formateData(item.children, item.id, item.subcompanycode)
            })
            if (!this.subcompanyname) {
              this.treeData = [{
                id: '杭氧',
                key: '杭氧',
                scopedSlots: { title: 'custom' },
                url: '杭氧',
                code: '杭氧',
                parent: true,
                children: res.data
              }]
            } else {
              this.treeData = res.data
            }
            this.defaultSelectedKeys = [this.treeData[0].key]
            this.selectedKeys = [this.treeData[0].key]
          } else {
            this.treeData = res.data
            this.defaultSelectedKeys = []
            this.selectedKeys = []
          }
          this.handleCentralizedManagementCompanyId({
            id: this.treeData.length > 0 ? this.treeData[0].id : '空',
            data: this.treeData.length > 0 ? this.treeData[0] : '空',
            numberOfUpdates: this.numberOfUpdates++
          })
          this.loading = false
        } else {
          this.$message.error(res.info.message)
          this.loading = false
        }
      })
    },
    // 调用父组件的获取资产类型数据方法
    searchAssetTypeList (data, info) {
      if (data.length > 0) {
        this.selectedKeys = data
        let id = ''
        let item = {}
        // 存subcompanycode到VueX中，并且在资产文件和表格文件中做监听
        if (info.selectedNodes.length > 0) {
          id = info.selectedNodes[0].data.props.id
          item = info.selectedNodes[0].data.props
        }
        this.handleCentralizedManagementCompanyId({
          id: id,
          data: item,
          numberOfUpdates: this.numberOfUpdates++
        })
      }
    },
    // 搜索设备分类
    queryDictData () {
      this.getDeptData()
    }
  }
}
</script>
<style lang="less">
.ant-modal-body {
  #chart-container {
    overflow-x: auto;
  }
}

.ant-tooltip {
  z-index: 1020;
}
.content-panel {
  height: 100%;
  .action-btn-line {
    display: flex;
    justify-content: space-between;
  }

  .ant-tree-title {
    width: 100%;

    & > span {
      // width: 90px;
      display: inline-block;
      white-space: pre-line !important;
    }
  }
  .title {
    float: left;
  }

  .ant-card-body {
    padding: 0;

    :global {
      .ant-tree {
        line-height: 3;

        .ant-tree-node-content-wrapper,
        .ant-tree-switcher {
          height: auto;
          margin-top: 5px;
          margin-bottom: 5px;
        }
        .ant-tree-switcher_close{
          background: url('../../../../src/assets/icon-close.svg') no-repeat 5px 4px !important;
          svg{
            display: none !important;
          }
        }
        .ant-tree-node-content-wrapper:hover {
          background: transparent;
        }
        .ant-tree-treenode-selected {
          background: #e6f7ff;
          height: auto !important;
          .ant-tree-node-selected {
            background: transparent;
          }
        }

        .ant-tree-child-tree {
          background: #fff;
        }
        li {
          position: relative;
          line-height: 3;
          padding-bottom: 0;
        }
      }
      .ant-btn {
        margin-bottom: 8px;
      }
    }

    .icon-panel {

      .anticon-plus,
      .anticon-setting,
      .anticon-edit,
      .anticon-delete {
        margin-left: 5px;
        color: #1890ff;
      }
    }
  }
}
/deep/.ant-tree-treenode-switcher-close  {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 0 4px 0 !important;
  height: auto;
  margin: 0 !important;
}
/deep/.ant-tree-node-content-wrapper-close {
  height: auto;
}
/deep/.ant-tree-treenode-switcher-open {
  padding: 0 !important;
}
/deep/.ant-tree-node-content-wrapper-open {
  margin: 0 !important;
  height: auto;
}
/deep/.ant-tree-node-content-wrapper {
  margin: 0 !important;
  height: auto;
}
/deep/.ant-tree-node-selected {
  height: auto;
}
.content-panel .ant-tree li {
  margin: 0!important;
  padding: 0!important;
  height: auto;
}
.content-panel .ant-tree li .ant-tree-child-tree {
  margin: 0!important;
}
/deep/.ant-tree li {
  margin: 0!important;
  padding: 0!important;
}
.spin {
  height: calc(100% - 40px);
  overflow: auto;
}
.treeCompanyName {
  font-size: 14px;
}
.contextmenu {
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: absolute;
  list-style-type: none;
  padding: 5px 4px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 3px 3px 8px 0 rgba(0, 0, 0, 0.3);
  width: 120px;
  text-align: center;
}

.contextmenu li {
  margin: 0;
  padding: 7px 16px;
  cursor: pointer;
}

.contextmenu li:hover {
  background: rgba(231, 244, 255, 1);
}
</style>
